/* eslint-disable import/no-unresolved */

import { getCategoryInfo } from './getCategoryInfo';

export function getIsCommercial(category: string | undefined): boolean {
  if (!category) {
    return false;
  }

  const { propertyType } = getCategoryInfo(category);

  return propertyType === 'commercial';
}
